(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[840],{

/***/ 1556:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-delivery",
      function () {
        return __webpack_require__(5113);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_0__);

var ResponseErrorServerSide = function(err) {
    if (err.response) {
        var ref, ref1;
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message, "", "error");
    } else if (err.request) {
        // The request was made but no response was received
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    } else {
        // Something happened in setting up the request that triggered an Error
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponseErrorServerSide);


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( true ? __webpack_require__(7294) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ international_delivery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@coreui/react/dist/index.es.js
var index_es = __webpack_require__(4475);
// EXTERNAL MODULE: ./components/index.js + 23 modules
var components = __webpack_require__(9765);
// EXTERNAL MODULE: ./components/ResponseErrorServerSide/index.js
var ResponseErrorServerSide = __webpack_require__(577);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./parts/courier-services/index.js + 1 modules
var courier_services = __webpack_require__(5267);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./parts/International-delivery/Devider/index.js


function Devider() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-md-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "progress",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "progress-bar",
                            role: "progressbar",
                            "aria-valuenow": "30",
                            "aria-valuemin": "0",
                            "aria-valuemax": "100",
                            style: {
                                width: "30%"
                            }
                        })
                    })
                })
            })
        })
    });
}
/* harmony default export */ var International_delivery_Devider = (Devider);

// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/International-delivery/AboutPage/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 


function AboutPage(param) {
    var data = param.data, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-md-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_title_about : data === null || data === void 0 ? void 0 : data.id_title_about
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "subtitle",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_subtitle_about : data === null || data === void 0 ? void 0 : data.id_subtitle_about
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_desc_about : data === null || data === void 0 ? void 0 : data.id_desc_about
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_img_about : data === null || data === void 0 ? void 0 : data.id_img_about,
                            alt: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_alt_img_about : data === null || data === void 0 ? void 0 : data.id_alt_img_about,
                            width: 546,
                            height: 304
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var International_delivery_AboutPage = (AboutPage);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./parts/International-delivery/OurServices/index.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 



function OurServices(param) {
    var en_service_text = param.en_service_text, id_service_text = param.id_service_text, data = param.data, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "title",
                            dangerouslySetInnerHTML: {
                                __html: language === "EN" ? en_service_text : id_service_text
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/international-delivery/".concat(language === "EN" ? item.id_slug : item.en_slug),
                            locale: language === "ID" ? "id" : "en",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-sm-6 col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "link-thumbnail",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "thumbnail",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: language === "EN" ? item.en_img : item.id_img,
                                                alt: language === "EN" ? item.en_alt_img : item.id_alt_img,
                                                width: 354,
                                                height: 220
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "caption",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item.en_name : item.id_name
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: language === "EN" ? item.en_desc : item.id_desc
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }, index);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var International_delivery_OurServices = (OurServices);

;// CONCATENATED MODULE: ./parts/International-delivery/index.js





// EXTERNAL MODULE: ./parts/landingpage/index.js + 9 modules
var landingpage = __webpack_require__(806);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./redux/toggleSlice.js
var toggleSlice = __webpack_require__(9756);
// EXTERNAL MODULE: ./utils/useLoading.js
var useLoading = __webpack_require__(471);
;// CONCATENATED MODULE: ./pages/international-delivery/index.js
/* eslint-disable jsx-a11y/alt-text */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/jsx-no-undef */ /* eslint-disable no-unused-vars */ 















function InternationalDelivery(param) {
    var product = param.product, landingPage = param.landingPage, headerFooter = param.headerFooter, coverageArea = param.coverageArea, isError = param.isError, lang = param.lang;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    // const language = useSelector((state) => state.toggle.language);
    var language = lang;
    var pathname = router.asPath.split("/").pop();
    var ref36 = (0,react.useState)(false), visible = ref36[0], setVisible = ref36[1];
    var prevScrollY = (0,react.useRef)(0);
    var ref37 = (0,react.useState)(false), goingUp = ref37[0], setGoingUp = ref37[1];
    var loading = (0,useLoading/* useLoading */.r)(false);
    // seo
    var seo = product === null || product === void 0 ? void 0 : product.state;
    // ===
    // navbar
    var navbar = headerFooter === null || headerFooter === void 0 ? void 0 : (ref = headerFooter.state) === null || ref === void 0 ? void 0 : ref.header;
    // ===
    // banner
    var banner = landingPage === null || landingPage === void 0 ? void 0 : (ref1 = landingPage.state) === null || ref1 === void 0 ? void 0 : ref1.banner;
    // ===
    // coverageArea
    var CoverageArea = [];
    coverageArea === null || coverageArea === void 0 ? void 0 : (ref2 = coverageArea.state) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(item) {
        CoverageArea.push(item.jvector_code);
    });
    // ===
    // navigasi menu
    var navigasiMenu = landingPage === null || landingPage === void 0 ? void 0 : (ref3 = landingPage.state) === null || ref3 === void 0 ? void 0 : ref3.navigationMenu;
    // ===
    // hero
    var newDataHeader = {
        banner_img: product === null || product === void 0 ? void 0 : (ref4 = product.state) === null || ref4 === void 0 ? void 0 : ref4.banner_img,
        cta_btn_id: product === null || product === void 0 ? void 0 : (ref5 = product.state) === null || ref5 === void 0 ? void 0 : ref5.cta_btn_id,
        en_desc: product === null || product === void 0 ? void 0 : (ref6 = product.state) === null || ref6 === void 0 ? void 0 : ref6.en_desc,
        en_title: product === null || product === void 0 ? void 0 : (ref7 = product.state) === null || ref7 === void 0 ? void 0 : ref7.en_title,
        id_desc: product === null || product === void 0 ? void 0 : (ref8 = product.state) === null || ref8 === void 0 ? void 0 : ref8.id_desc,
        id_title: product === null || product === void 0 ? void 0 : (ref9 = product.state) === null || ref9 === void 0 ? void 0 : ref9.id_title,
        headerCTA: product === null || product === void 0 ? void 0 : (ref10 = product.state) === null || ref10 === void 0 ? void 0 : ref10.headerCTA,
        additional_cta_btn_id: product === null || product === void 0 ? void 0 : (ref11 = product.state) === null || ref11 === void 0 ? void 0 : ref11.additional_cta_btn_id,
        additionalCTA: product === null || product === void 0 ? void 0 : (ref12 = product.state) === null || ref12 === void 0 ? void 0 : ref12.additionalCTA
    };
    var dataHero = newDataHeader;
    // ===
    //  about
    var newAbout = {
        en_desc_about: product === null || product === void 0 ? void 0 : (ref13 = product.state) === null || ref13 === void 0 ? void 0 : ref13.en_desc_about,
        en_img_about: product === null || product === void 0 ? void 0 : (ref14 = product.state) === null || ref14 === void 0 ? void 0 : ref14.en_img_about,
        en_subtitle_about: product === null || product === void 0 ? void 0 : (ref15 = product.state) === null || ref15 === void 0 ? void 0 : ref15.en_subtitle_about,
        en_title_about: product === null || product === void 0 ? void 0 : (ref16 = product.state) === null || ref16 === void 0 ? void 0 : ref16.en_title_about,
        en_alt_img_about: product === null || product === void 0 ? void 0 : (ref17 = product.state) === null || ref17 === void 0 ? void 0 : ref17.en_alt_img_about,
        id_desc_about: product === null || product === void 0 ? void 0 : (ref18 = product.state) === null || ref18 === void 0 ? void 0 : ref18.id_desc_about,
        id_img_about: product === null || product === void 0 ? void 0 : (ref19 = product.state) === null || ref19 === void 0 ? void 0 : ref19.id_img_about,
        id_subtitle_about: product === null || product === void 0 ? void 0 : (ref20 = product.state) === null || ref20 === void 0 ? void 0 : ref20.id_subtitle_about,
        id_title_about: product === null || product === void 0 ? void 0 : (ref21 = product.state) === null || ref21 === void 0 ? void 0 : ref21.id_title_about,
        id_alt_img_about: product === null || product === void 0 ? void 0 : (ref22 = product.state) === null || ref22 === void 0 ? void 0 : ref22.id_alt_img_about
    };
    var dataAbout = newAbout;
    // ===
    // services
    var newProducts = {
        en_service_text: product === null || product === void 0 ? void 0 : (ref23 = product.state) === null || ref23 === void 0 ? void 0 : ref23.en_service_text,
        id_service_text: product === null || product === void 0 ? void 0 : (ref24 = product.state) === null || ref24 === void 0 ? void 0 : ref24.id_service_text,
        product: product === null || product === void 0 ? void 0 : (ref25 = product.state) === null || ref25 === void 0 ? void 0 : ref25.Products
    };
    var dataOurProducts = newProducts;
    // ===
    // client
    var newClient = {
        en_client_text: product === null || product === void 0 ? void 0 : (ref26 = product.state) === null || ref26 === void 0 ? void 0 : ref26.en_client_text,
        id_client_text: product === null || product === void 0 ? void 0 : (ref27 = product.state) === null || ref27 === void 0 ? void 0 : ref27.id_client_text,
        client: product === null || product === void 0 ? void 0 : (ref28 = product.state) === null || ref28 === void 0 ? void 0 : ref28.client
    };
    var dataClient = newClient;
    // ===
    // partner
    var newPartner = {
        id_partner_text: product === null || product === void 0 ? void 0 : (ref29 = product.state) === null || ref29 === void 0 ? void 0 : ref29.id_partner_text,
        en_partner_text: product === null || product === void 0 ? void 0 : (ref30 = product.state) === null || ref30 === void 0 ? void 0 : ref30.en_partner_text,
        partner: product === null || product === void 0 ? void 0 : (ref31 = product.state) === null || ref31 === void 0 ? void 0 : ref31.partner
    };
    var dataPartner = newPartner;
    // ===
    // cta fixed
    var dataCTA = product === null || product === void 0 ? void 0 : product.state;
    var newCTAFixed = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.stickyCTA), {
        sticky_cta_btn_id: dataCTA === null || dataCTA === void 0 ? void 0 : dataCTA.sticky_cta_btn_id
    });
    var dataCTAFixed = newCTAFixed;
    // ===
    // section cta
    var newDataCTAsection = product === null || product === void 0 ? void 0 : product.state;
    var newDataCTA = newDataCTAsection === null || newDataCTAsection === void 0 ? void 0 : newDataCTAsection.CTAButton;
    var dataCTASection = {
        newDataCTA: newDataCTA,
        en_cta_text: newDataCTAsection === null || newDataCTAsection === void 0 ? void 0 : newDataCTAsection.en_cta_text,
        id_cta_text: newDataCTAsection === null || newDataCTAsection === void 0 ? void 0 : newDataCTAsection.id_cta_text
    };
    // ===
    // footer
    var footer = headerFooter === null || headerFooter === void 0 ? void 0 : (ref32 = headerFooter.state) === null || ref32 === void 0 ? void 0 : ref32.footer;
    // ===
    (0,react.useEffect)(function() {
        var ref;
        var handleScroll = function() {
            if (true) {
                var ref;
                var currentScrollY = window.scrollY;
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) < currentScrollY && goingUp) {
                    setGoingUp(false);
                }
                if ((prevScrollY === null || prevScrollY === void 0 ? void 0 : prevScrollY.current) > currentScrollY && !goingUp) {
                    setGoingUp(true);
                }
                var startY = (ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight;
                prevScrollY.current = currentScrollY;
                //
                if (currentScrollY > startY) {
                    var ref1;
                    var el = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el === null || el === void 0 ? void 0 : (ref1 = el.classList) === null || ref1 === void 0 ? void 0 : ref1.add("scrolled");
                } else {
                    var ref2;
                    var el1 = document.querySelectorAll(".codrops-top-for-page-detail")[0];
                    el1 === null || el1 === void 0 ? void 0 : (ref2 = el1.classList) === null || ref2 === void 0 ? void 0 : ref2.remove("scrolled");
                }
            }
        };
        if (((ref = document.querySelectorAll(".codrops-top-for-page-detail")[0]) === null || ref === void 0 ? void 0 : ref.clientHeight) > 0) {
            if (true) {
                window.addEventListener("scroll", function() {
                    handleScroll();
                });
                window.addEventListener("load", function() {
                    handleScroll();
                });
                window.addEventListener("resize", function() {
                    handleScroll();
                });
            }
        }
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        goingUp
    ]);
    var handleChangeLanguage = function() {
        if (language === "EN") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "ID"
            }));
            router.push("/" + pathname, "/" + pathname, {
                locale: "id"
            });
        } else {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "EN"
            }));
            router.push("/" + pathname, "/" + pathname, {
                locale: "en"
            });
        }
    };
    (0,react.useEffect)(function() {
        // check first load
        if (language === "ID") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "ID"
            }));
        }
        if (language === "EN") {
            dispatch((0,toggleSlice/* setToggle */.rd)({
                language: "EN"
            }));
        }
    }, []);
    var topFunction = function() {
        setVisible(function(currentValue) {
            return !currentValue;
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var openNav = function() {
        document.getElementById("mySidenav").style.width = "320px";
    };
    var closeNav = function() {
        document.getElementById("mySidenav").style.width = "0";
    };
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LoadingScreen */.a_, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponseErrorServerSide/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_seo_page_title : seo === null || seo === void 0 ? void 0 : seo.en_seo_page_title,
                description: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_desc : seo === null || seo === void 0 ? void 0 : seo.en_meta_desc,
                additionalMetaTags: [
                    {
                        property: "keywords",
                        content: language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_meta_keyword : seo === null || seo === void 0 ? void 0 : seo.en_meta_keyword
                    }
                ],
                additionalLinkTags: [
                    {
                        rel: "canonical",
                        href: "".concat("https://cklcargo.com/").concat(language === "ID" ? seo === null || seo === void 0 ? void 0 : seo.id_slug : seo === null || seo === void 0 ? void 0 : seo.en_slug)
                    },
                    {
                        rel: "icon",
                        href: navbar === null || navbar === void 0 ? void 0 : navbar.web_icon
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCollapse */.V9, {
                        visible: visible,
                        id: "collapse-top-index",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card card-body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BackgroundBannerDefault */.M4, {
                                    data: banner,
                                    language: language
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(landingpage/* MainContent */.M9, {
                                    language: language,
                                    data: navigasiMenu,
                                    CoverageArea: CoverageArea
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "col-top-nav",
                        className: "codrops-top codrops-top-for-page-detail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(courier_services/* NavbarCourierServices */.O, {
                                topFunction: topFunction,
                                data: navbar,
                                changeLanguage: handleChangeLanguage,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Sidebar */.DD, {
                                changeLanguage: handleChangeLanguage,
                                closeNav: closeNav,
                                openNav: openNav,
                                topFunction: topFunction,
                                data: navbar,
                                language: language
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-main-page col-main-page-detail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Hero */.VM, {
                                breadcrump: navbar,
                                language: language,
                                dataHeader: dataHero
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(International_delivery_AboutPage, {
                                data: dataAbout,
                                language: language
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(International_delivery_Devider, {}),
                            (dataOurProducts === null || dataOurProducts === void 0 ? void 0 : (ref33 = dataOurProducts.product) === null || ref33 === void 0 ? void 0 : ref33.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(International_delivery_OurServices, {
                                language: language,
                                data: dataOurProducts === null || dataOurProducts === void 0 ? void 0 : dataOurProducts.product,
                                en_service_text: dataOurProducts === null || dataOurProducts === void 0 ? void 0 : dataOurProducts.en_service_text,
                                id_service_text: dataOurProducts === null || dataOurProducts === void 0 ? void 0 : dataOurProducts.id_service_text
                            }),
                            (dataClient === null || dataClient === void 0 ? void 0 : (ref34 = dataClient.client) === null || ref34 === void 0 ? void 0 : ref34.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OurClient */.rh, {
                                client: dataClient === null || dataClient === void 0 ? void 0 : dataClient.client,
                                id_title: dataClient === null || dataClient === void 0 ? void 0 : dataClient.id_client_text,
                                en_title: dataClient === null || dataClient === void 0 ? void 0 : dataClient.en_client_text,
                                language: language
                            }),
                            (dataPartner === null || dataPartner === void 0 ? void 0 : (ref35 = dataPartner.partner) === null || ref35 === void 0 ? void 0 : ref35.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OurPartner */._Y, {
                                id_title: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.id_partner_text,
                                en_title: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.en_partner_text,
                                language: language,
                                partner: dataPartner === null || dataPartner === void 0 ? void 0 : dataPartner.partner
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CTA */.MV, {
                                CTAButton: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.newDataCTA,
                                language: language,
                                id_desc: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.id_cta_text,
                                en_desc: dataCTASection === null || dataCTASection === void 0 ? void 0 : dataCTASection.en_cta_text
                            })
                        ]
                    }),
                    (dataCTAFixed === null || dataCTAFixed === void 0 ? void 0 : dataCTAFixed.sticky_cta_btn_id) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* WAFixed */.Fs, {
                        data: dataCTAFixed
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FooterFrontend */.YE, {
                        footer: footer,
                        language: language
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var international_delivery = (InternationalDelivery);


/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ courier_services_NavbarCourierServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/courier-services/NavbarCourierServices/index.js
/* eslint-disable no-unused-vars */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 




function NavbarCourierServices(param) {
    var topFunction = param.topFunction, data = param.data, changeLanguage = param.changeLanguage, language = param.language;
    // buat misahin posisi menu navbar
    var idFreeConsultation = 20;
    // buat conditional routing per id detail
    var idCourier = 2;
    var idInternational = 7;
    // buat redirect ke luar web
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                locale: language === "ID" ? "id" : "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : data.logo,
                        alt: data === null || data === void 0 ? void 0 : data.alt_logo,
                        // layout="fill"
                        width: 125,
                        height: 62
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "top-nav-menu",
                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        }),
                                                        child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "subs-nav",
                                                                children: child.child.map(function(childofchild, childofchildIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                locale: language === "ID" ? "id" : "en",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                })
                                                                            })
                                                                        }, childofchildIndex)
                                                                    });
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "ID" ? "/" + (item === null || item === void 0 ? void 0 : item.id_url) : "/" + (item === null || item === void 0 ? void 0 : item.en_url),
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    })
                                })
                            })
                        })
                    });
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu top-consultation",
                        children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                            return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                        locale: language === "ID" ? "id" : "en",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        })
                                                    })
                                                }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                    })
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://cklcargo.com/", "/assets/icons/globe.png"),
                                            width: 39,
                                            height: 30,
                                            alt: "ckl-logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: topFunction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat("https://cklcargo.com/", "/assets/icons/home.png"),
                            width: 39,
                            height: 30,
                            alt: "home"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var courier_services_NavbarCourierServices = (NavbarCourierServices);

;// CONCATENATED MODULE: ./parts/courier-services/index.js




/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* unused reexport */ __webpack_require__(699)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,617,645,498,74,806,774,888,179], function() { return __webpack_exec__(1556); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);